// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fa-home,body[data-scrolltop=on] .home-icon-color{color:#6cdb72}body[data-scrolltop=on] .has-background .menu-item-active .menu-link,body[data-scrolltop=on] .has-background .menu-item.menu-item-hover .menu-link,body[data-scrolltop=on] .has-background .menu-item:hover .menu-link{background-color:hsla(0,0%,100%,.1)!important}body[data-scrolltop=on] .has-background :not(.exact-color i,.menu-submenu *){color:#fff!important}", ""]);
// Exports
module.exports = exports;
